import * as React from "react";
import { GafOktaManager } from "../../auth/gaf-okta-auth";
import { Redirect } from "react-router-dom";
import { removeSessionBeforeUnload } from "../../utils/utils";

export class HomeLoggedIn extends React.Component<any, any> {
    state = {
        authenticated: null,
        error: null,
    };

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        const authenticated = GafOktaManager.isAuthenticated;
        this.setState({ authenticated });
    }
    render() {
        if (this.state.authenticated === null) {
            return null;
        }
        removeSessionBeforeUnload();
        if (GafOktaManager.isAuthenticated) {
            return <Redirect to="/" />;
        } else {
            return <Redirect to="/homenotloggedin" />;
            /*
            We might need to use one of the following.
            <React.Fragment>
              <div>
                You are logged in as{" "}
                <b>{GafOktaManager.storage.info.profile?.email}</b>
                <br />
                <br />
                Your Id_token is <b>{GafOktaManager.storage.info.idToken}</b>
                <br />
                <br />
                Your accessToken is <b>{GafOktaManager.storage.info.accessToken}</b>
                <br />
                <br />
                <button
                  className="btn btn-default ml-2"
                  onClick={evt => GafOktaManager.logout()}
                >
                  Logout
                </button>
              </div>
            </React.Fragment>
          */
        }
    }
}
